import { render, staticRenderFns } from "./EyeContourSection.vue?vue&type=template&id=e3de648a&scoped=true"
import script from "./EyeContourSection.vue?vue&type=script&lang=js"
export * from "./EyeContourSection.vue?vue&type=script&lang=js"
import style0 from "./EyeContourSection.vue?vue&type=style&index=0&id=e3de648a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3de648a",
  null
  
)

export default component.exports